<div class="time-picker-wrap">
  <div (click)="$event.preventDefault()" class="time-picker-content">
    <rt-group class="group-switcher" variant="horizontal stacked">
      <rt-segmented-control
        [type]="'view-switcher'"
        [fullwidth]="true"
        [segmentedButtons]="segmentedButtons"
        (segmentedButtonClicked)="switchTab($event)"
        layout-full-width
      >
      </rt-segmented-control>
    </rt-group>

    <div class="tabs">
      @if (activeTab === 'date') {
        <div class="tab tab-date">
          <rt-date-picker
            [value]="tmpValue!.date"
            [direction]="direction"
            (valueChange)="handleDateChange($event!)"
          >
          </rt-date-picker>
        </div>
      }

      @if (activeTab === 'time') {
        <div class="tab tab-time">
          <div class="inputs-wrap">
            <rt-input
              variant="rounded"
              [value]="tmpValue!.time"
              (valueChange)="handleTimeChange($event!)"
              (click)="timeDropdown.open = !timeDropdown.open"
              rt-overlay-origin
              #timeDropdownTrigger="rtOverlayOrigin"
            >
            </rt-input>
          </div>

          <div class="time-zone-wrap">
            <rt-time-zone-picker
              [small]="true"
              [timezone]="tmpValue!.zone"
              (zoneChange)="handleTimeZoneChange($event)"
            ></rt-time-zone-picker>
          </div>

          <ng-template
            #timeDropdown="rtConnectedOverlay"
            [origin]="timeDropdownTrigger"
            [width]="120"
            [hasBackdrop]="true"
            (backdropClick)="timeDropdown.open = false"
            rt-connected-overlay
          >
            <rt-time-picker-dropdown
              [currentSelected]="tmpValue!.time"
              [timeInterval]="timeInterval"
              [blockPastTime]="blockPastTime && isPresentDaySelected"
              (timeSelect)="handleTimeChange($event)"
            >
            </rt-time-picker-dropdown>
          </ng-template>
        </div>
      }
    </div>
  </div>

  @if (showDoneButton && ((!showTimeZonePicker && activeTab === 'time') || activeTab === 'date')) {
    <div class="action">
      <rt-button (click)="applyChanges()" variant="primary">
        <rt-icon name="check"></rt-icon>
        <span>{{ 'rtu.common.done' | translate }}</span>
      </rt-button>
    </div>
  }
</div>
